import { render, staticRenderFns } from "./PreapprovedInvoiceAttachmentModal.vue?vue&type=template&id=6278712e"
import script from "./PreapprovedInvoiceAttachmentModal.vue?vue&type=script&lang=js"
export * from "./PreapprovedInvoiceAttachmentModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/stage.cashnow.d-resources.com/releases/67404460/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6278712e')) {
      api.createRecord('6278712e', component.options)
    } else {
      api.reload('6278712e', component.options)
    }
    module.hot.accept("./PreapprovedInvoiceAttachmentModal.vue?vue&type=template&id=6278712e", function () {
      api.rerender('6278712e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/modal/PreapprovedInvoiceAttachmentModal.vue"
export default component.exports